import React from 'react';

export const TextAreaAdornment = () => (
  <div className="textarea-icon">
    <div className="line-big" />
    <div className="line-small" />
  </div>
);
